import { profileKey } from '@staffedupusa/shared-components';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { enterpriseInviteRoute } from '@features/enterprise/api/constants';
import { errorMessage } from '@features/profile';
import axiosInstance from '@server/axiosInstance';

type useSendEnterpriseEmailsProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
  setSuccessText?: Dispatch<SetStateAction<string>>;
  setShowEmailInputs?: Dispatch<SetStateAction<boolean>>;
};

export const useSendEnterpriseEmails = ({
  setErrorText = () => { },
  setSuccessText = () => { },
  setShowEmailInputs = () => { },
}: useSendEnterpriseEmailsProps) => {
  const client = useQueryClient();

  const { mutate: sendEnterpriseEmails, isLoading: isSendingEnterpriseEmails } =
    useMutation({
      mutationFn: (variables: { email: string }) =>
        axiosInstance
          .post(enterpriseInviteRoute, variables)
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          setShowEmailInputs(false)
          setSuccessText(data.message)
          client.invalidateQueries([profileKey]);
        }
      },
      onError: () => setErrorText(errorMessage),
    });
  return {
    sendEnterpriseEmails,
    isSendingEnterpriseEmails,
  };
};
